module.exports = __webpack_public_path__ + "img/grundung-2.203386e6.jpg";